export default __webpack_public_path__ + "static/char-s-32-ja-8574d6e4a0adee3a33f3a8d3fa6cb7f2.webp";